window.track = (serviceName, partnerName, partnerSlug, label) => {
    if(window.ga) {
        ga('send', 'event', serviceName, partnerName, label);
    }
    if (window._tfa) {
        _tfa.push({notify: 'event', name: partnerSlug, id: 1161559});
    }
    if (window.fbq) {
        fbq('track', 'Lead');
        fbq('track', 'Search', {search_string: partnerSlug});
    }
    if (window.obApi) {
        obApi('track', partnerSlug + " Lead");
    }
}